import React from 'react';
import { FontWeights, getTheme, mergeStyleSets, Modal } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import CloseModalButtonComponent from '../close-modal-button/close-modal-button.component';

const theme = getTheme();

const classes = mergeStyleSets({
    header: [
        theme.fonts.xLargePlus, {
            flex: '1 1 auto',
            color: theme.palette.neutralPrimary,
            display: 'flex',
            justifyContent: 'space-between',
            fontWeight: FontWeights.semibold,
            padding: '12px 24px 14px 24px',
            width: '100%',
        },
    ],
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: { 
                margin: '14px 0',
            },
            'p:first-child': { 
                marginTop: 0,
            },
            'p:last-child': { 
                marginBottom: 0,
            },
        },
    },
    scrollableContent: {
        height: '100%',
    },
});

interface IModalDefaultComponentProps {
    title: string;
    onDismiss: () => void;
    children: JSX.Element;
    className?: string;
};

const ModalDefaultComponent = (props: IModalDefaultComponentProps) => {
    const titleId = useId("modal-default");

    return (
        <Modal
            titleAriaId={titleId}
            isOpen={true}
            onDismiss={props.onDismiss}
            isBlocking={false}
            scrollableContentClassName={classes.scrollableContent}
            containerClassName="h-100 w-100 overflow-hidden"
            className={props.className}>
            <section className={classes.header}>
                <span>
                    {props.title}
                </span>
                <CloseModalButtonComponent onClick={props.onDismiss} />
            </section>
            <section className={classes.body}>
                {props.children}
            </section>
        </Modal>
    );
};

export default ModalDefaultComponent;
